import type { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { type ControlInterface, nonBlankValidator, postalCodeValidator } from '@comparit/core';
import type { Step4FormInput } from '../../../interfaces';

export class Step4Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step4FormInput | null
  ) {}

  ctrls: ControlInterface<Step4FormInput> = {
    // nonBlankValidator is load-bearing here, not decoration: postalCodeValidator() returns null
    // for a blank value and Validators.required passes a space, so '   ' would otherwise clear
    // the step.
    plz: this.fb.control<string>(this.defaultValue?.plz ?? '', [
      Validators.required,
      nonBlankValidator(),
      postalCodeValidator(),
    ]),
    ort: this.fb.control<string>(this.defaultValue?.ort ?? '', [
      Validators.required,
      nonBlankValidator(),
    ]),
    strasse: this.fb.control<string>(this.defaultValue?.strasse ?? '', [
      Validators.required,
      nonBlankValidator(),
    ]),
    hausnummer: this.fb.control<string>(this.defaultValue?.hausnummer ?? '', [
      Validators.required,
      nonBlankValidator(),
    ]),
  };

  public fg = this.fb.group(this.ctrls);
}
